var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.5,7.7C125.4,7.7,14.2,118.9,14.2,256s111.2,248.3,248.3,248.3S510.8,393.1,510.8,256S399.6,7.7,262.5,7.7z M189.6,388 h-54.7V211.7h54.7V388z M162.2,187.7c-17.5,0-31.7-14.5-31.7-32c0-17.5,14.2-31.7,31.7-31.7c17.5,0,31.7,14.2,31.7,31.7 C193.9,173.2,179.7,187.7,162.2,187.7z M394.5,388L394.5,388h-54.7v-85.8c0-20.4-0.4-46.7-28.5-46.7c-28.5,0-32.8,22.2-32.8,45.2 V388h-54.7V211.7h52.5v24h0.8c7.3-13.8,25.2-28.5,51.8-28.5c55.4,0,65.6,36.5,65.6,83.9V388z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Linkedin.47326cc52c84ca2abb9de41ce7a5e89b.svg";